import React from "react";
import { AiFillApple } from "react-icons/ai";
import "./Buttons.css";
import { useTranslation } from "react-i18next";
const DownloadOnAppStoreMobile = () => {
  const { t } = useTranslation();
  return (
    <>
      <a href="##" className="mobile-button-link">
        <div className="mobile-button-flex">
          <div className="download-icon-mobile">
            <AiFillApple className="icon" />
          </div>
          <div className="download-text-mobile">
            <p>
              {t("Download")} {t("on")}{" "}
            </p>
            <h5>Apple Store</h5>
          </div>
        </div>
      </a>
    </>
  );
};

export default DownloadOnAppStoreMobile;
